import { createSlice } from "@reduxjs/toolkit";
import {
    fetchEmployees,
    fetchShippingCompanies,
    createOrder,
    fetchOrders
} from "../actions/orderAction";

const orderSlice = createSlice({
    name: "order",
    initialState: {
        employees: [],
        shippingCompanies: [],
        orders: [],
        latestOrder: null,
        status: "idle",
        error: null,
    },
    reducers: {
        clearOrderError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch Employees
            .addCase(fetchEmployees.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchEmployees.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.employees = action.payload.data || [];
            })
            .addCase(fetchEmployees.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload?.message || "Failed to fetch employees";
            })

            // Fetch Shipping Companies
            .addCase(fetchShippingCompanies.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchShippingCompanies.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.shippingCompanies = action.payload.data || [];
            })
            .addCase(fetchShippingCompanies.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload?.message || "Failed to fetch shipping companies";
            })

            // Create Order
            .addCase(createOrder.pending, (state) => {
                state.status = "loading";
            })
            .addCase(createOrder.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.latestOrder = action.payload.data;
                state.error = null;
            })
            .addCase(createOrder.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload?.message || "Failed to create order";
            })

            // Fetch Orders
            .addCase(fetchOrders.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchOrders.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.orders = action.payload.data || [];
            })
            .addCase(fetchOrders.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload?.message || "Failed to fetch orders";
            });
    },
});

export const { clearOrderError } = orderSlice.actions;
export default orderSlice.reducer;
